import { Box, BoxProps, Flex, Wrap } from "@zenchef/styled-system/jsx";
import ContextualIcon from "../../ContextualIcon/ContextualIcon";
import { Text } from "../../typography/Text";
import { IconName } from "@zenchef/icomoon";
import {
  aromaFiguresCard,
  AromaFiguresCardVariantProps,
} from "@zenchef/styled-system/recipes";
import { ElementRef, forwardRef, ReactNode } from "react";

export interface FiguresCardProps
  extends AromaFiguresCardVariantProps,
    BoxProps {
  iconName: IconName;
  label: string;
  description?: string;
  value: string;
  action?: ReactNode;
}

const FiguresCard = forwardRef<ElementRef<"div">, FiguresCardProps>(
  (
    { iconName, label, description, value, action, ...propsWithVariants },
    ref,
  ) => {
    const [variants, props] =
      aromaFiguresCard.splitVariantProps(propsWithVariants);
    const classes = aromaFiguresCard(variants);

    return (
      <Box className={classes.root} {...props} ref={ref}>
        <Flex className={classes.content}>
          <ContextualIcon
            width="m"
            height="m"
            hierarchy="subtle"
            name={iconName}
          />
          <Flex className={classes.text}>
            <Text textStyle="title.s">{label}</Text>
            <Text
              textStyle="paragraph.s.regular"
              color="content.neutral.base.subtlest"
            >
              {description}
            </Text>
          </Flex>
        </Flex>
        {action ? (
          <Wrap className={classes.rightPart}>
            <Wrap className={classes.value}>
              <Text textStyle="paragraph.l.bold" width="100%">
                {value}
              </Text>
            </Wrap>
            <Wrap className={classes.action}>{action}</Wrap>
          </Wrap>
        ) : (
          <Wrap className={classes.value}>
            <Text textStyle="paragraph.l.bold" width="100%">
              {value}
            </Text>
          </Wrap>
        )}
      </Box>
    );
  },
);

FiguresCard.displayName = "FiguresCard";

export default FiguresCard;
